import { sendGAEvent } from '@noths/polaris-client-google-analytics';
export var trackAccordionExpanded = function trackAccordionExpanded(selectedSection) {
  sendGAEvent({
    event: 'custom_event',
    event_category: 'Footer',
    event_action: "".concat(selectedSection, " expand"),
    event_label: 'not set'
  });
};